import { defineComponent as _defineComponent } from 'vue'
import CurrencyValue from '@/components/CurrencyValue.vue';
import { Icons } from '@/font-awesome';
import { BenefitsCardPlan } from '@/models/benefits_cards/benefits_card_plan_model';
import FormatUtils from '@/utils/format_utils';
import { getCurrentInstance } from 'vue';
import ContextMenu from '../ContextMenu.vue';
// import ToggleActive from '@/components/ToggleActive.vue';
import Tooltip from '@/components/Tooltip.vue';
import LoggedAdminStorage from '@/infra/local_storage/logged_admin_storage';
import { Permission } from '@/models/admins/permission_model';
import { Resource } from '@/models/admins/resources_enum';
import { CardCategoryUtils } from '@/models/benefits_cards/card_category_type';
import CardBlob from '../CardBlob.vue';
import CardTag from '../CardTag.vue';

const textEllipsisSize = 14;


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitsCardPlanCard',
  props: {
    benefitsCardPlan: { type: Object, required: true },
    hideControls: { type: Boolean, required: false }
  },
  emits: ["change-page", "renew", "remove"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const thisInstance = getCurrentInstance();

const props = __props;

const emit = __emit;


const __returned__ = { thisInstance, props, emit, textEllipsisSize, CurrencyValue, get Icons() { return Icons }, get FormatUtils() { return FormatUtils }, ContextMenu, Tooltip, get LoggedAdminStorage() { return LoggedAdminStorage }, get Permission() { return Permission }, get Resource() { return Resource }, get CardCategoryUtils() { return CardCategoryUtils }, CardBlob, CardTag }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})